export const TemplateType = {
  FlightDeck: 'flight_deck',
  Entrance: 'entrance',
  Tunnel: 'tunnel',
  PODS: 'pods',
  Backroom: 'backroom',
  BlowerRoom: 'blower_room',
  Vacuums: 'vacuums',
  FlexBay: 'flex_bay',
  LaundryRoom: 'laundry_room',
  GuestWaitingArea: 'guest_waiting_area',
};

export const TemplateTypeLabel = {
  [TemplateType.FlightDeck]: 'Flight Deck',
  [TemplateType.Entrance]: 'Entrance',
  [TemplateType.Tunnel]: 'Tunnel',
  [TemplateType.PODS]: 'PODS',
  [TemplateType.Backroom]: 'Backroom',
  [TemplateType.BlowerRoom]: 'Blower Room',
  [TemplateType.Vacuums]: 'Vacuums',
  [TemplateType.FlexBay]: 'Flex Bay',
  [TemplateType.LaundryRoom]: 'Laundry Room',
  [TemplateType.GuestWaitingArea]: 'Guest Waiting Area',
};

export const AssetNodeType = {
  Template: 'template',
  Collection: 'collection',
  Group: 'group',
  Item: 'item',
};

export const AssetNodeTypeLabel = {
  [AssetNodeType.Template]: 'Template',
  [AssetNodeType.Collection]: 'Collection',
  [AssetNodeType.Group]: 'Group',
  [AssetNodeType.Item]: 'Item',
};

export const StockStatus = {
  InStock: 'in_stock',
  LowStock: 'low_stock',
  OutOfStock: 'out_of_stock',
};

export const StockStatusLabel = {
  [StockStatus.InStock]: 'In Stock',
  [StockStatus.LowStock]: 'Low Stock',
  [StockStatus.OutOfStock]: 'Out of Stock',
};

export const TaskFrequency = {
  Daily: 'daily',
  Weekly: 'weekly',
  Monthly: 'monthly',
};

export const PmPriority = {
  Low: 'low',
  Medium: 'medium',
  High: 'high',
  Critical: 'critical',
};

export const emptyAssetTree = {
  id: null,
  name: '',
  type: AssetNodeType.Template,
  taskCount: 0,
  pmCount: 0,
  projectCount: 0,
  inventoryCount: 0,
  children: [],
};
